import React from 'react';

import _ from '../locale';
import { styled } from '../theme';
import FieldStatusText from './FieldStatusText';

const Input = styled('input')`
    flex-grow: 1;
    width: 100%;
    max-width: calc(100% - 90px);
    box-sizing: border-box;
    margin-left: 10px;
    border-width: 0 0 1px 0;
`;

type Props = {
    className?: string;
    name: string;
    value: string;
    maxLength?: number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onPaste?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
    showWarning?: boolean;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

const InputComment: React.FC<Props> = ({
    name,
    value,
    maxLength = 128,
    onChange,
    onPaste,
    showWarning = false,
    onBlur,
    className,
    ...props
}) => (
    <>
        <Input
            className={className}
            type="text"
            name={name}
            value={value}
            maxLength={maxLength}
            placeholder={_('please_specify')}
            onChange={onChange}
            onPaste={onPaste}
            onBlur={onBlur}
            {...props}
        />
        <FieldStatusText status="error">
            {showWarning ? _('error_pasted_text_was_cropped', { max: maxLength }) : ''}
        </FieldStatusText>
    </>
);

export default InputComment;
